import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 
            className="text-3xl font-semibold text-zinc-900 mb-8"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            data-testid="terms-title"
          >
            Conditions d'utilisation
          </h1>

          <div className="bg-white border border-zinc-200 rounded-xl p-8 prose prose-zinc max-w-none">
            <h2>1. Acceptation des conditions</h2>
            <p>
              En utilisant JobMatch CV, vous acceptez les présentes conditions d'utilisation. 
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
            </p>

            <h2>2. Description du service</h2>
            <p>
              JobMatch CV est un service d'analyse de CV par intelligence artificielle qui :
            </p>
            <ul>
              <li>Compare votre CV avec des offres d'emploi</li>
              <li>Génère des scores de compatibilité</li>
              <li>Propose des optimisations de CV</li>
              <li>Génère des lettres de motivation</li>
            </ul>

            <h2>3. Responsabilité de l'utilisateur</h2>
            <p>
              <strong>Important :</strong> Vous êtes responsable de vérifier tous les contenus générés 
              avant leur utilisation. L'IA peut commettre des erreurs ou mal interpréter des informations.
            </p>

            <h2>4. Garantie de non-invention</h2>
            <p>
              Notre IA est conçue pour ne jamais inventer d'informations. Elle reformule et réorganise 
              uniquement les éléments présents dans votre CV original. Cependant, vous devez toujours 
              vérifier l'exactitude des contenus générés.
            </p>

            <h2>5. Limitation de responsabilité</h2>
            <p>
              JobMatch CV ne peut être tenu responsable :
            </p>
            <ul>
              <li>Des décisions de recrutement basées sur nos analyses</li>
              <li>Des erreurs dans les contenus générés</li>
              <li>De l'utilisation des informations fournies</li>
            </ul>

            <h2>6. Propriété intellectuelle</h2>
            <p>
              Vous conservez tous les droits sur vos CV et documents originaux. 
              Les contenus générés par notre IA vous appartiennent entièrement.
            </p>

            <h2>7. Paiement et remboursement</h2>
            <p>
              L'abonnement Premium est facturé mensuellement. Vous pouvez annuler à tout moment. 
              Aucun remboursement n'est effectué pour la période en cours.
            </p>

            <h2>8. Modification des conditions</h2>
            <p>
              Nous nous réservons le droit de modifier ces conditions. Les utilisateurs seront 
              informés de tout changement significatif par email.
            </p>

            <h2>9. Contact</h2>
            <p>
              Pour toute question : <a href="mailto:contact@jobmatch-cv.com">contact@jobmatch-cv.com</a>
            </p>

            <div className="mt-8 p-4 bg-amber-50 border border-amber-200 rounded-lg">
              <p className="text-amber-800 font-medium mb-2">⚠️ Rappel important</p>
              <p className="text-amber-700 text-sm">
                L'IA n'invente aucune expérience ou compétence. Veuillez vérifier les contenus 
                générés avant utilisation. Vous êtes responsable de l'exactitude de vos candidatures.
              </p>
            </div>

            <p className="text-sm text-zinc-500 mt-8">
              Dernière mise à jour : Janvier 2026
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
